<template>
    <div>
        <PageBanner :pageTitle="$t('sidebar_inonlays_title_six')" />

        <InOnLaysNot/>
    </div>
</template>

<script>
import InOnLaysNot from '../blog-details/InOnLaysNot.vue'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
       PageBanner,
InOnLaysNot    }
}
</script>